<template>

  <div class="basket">
    <div
      style="padding-top: 28px"
      v-if="loader().WEBVIEW_MODE === loader().const.ECOMMERCE"
    ></div>
    <div class="basket_inner">
      <div class="basket_head">
        <div class="bh_left">
          <router-link
            :to="{ name: 'home', params: { token: this.$store.getters.token } }"
            class="bh_back"
          >
            <img
              :src="require('@/assets/img/facebook/back_str.svg')"
              alt="back"
            >
          </router-link>
          <div class="bh_title">{{ text('screen_basket_title') }}</div>
        </div>
        <div
          class="bh_ico"
          v-if="$store.getters.selectedProducts.length > 0"
          @click="openClearModal"
        ><img :src="require('@/assets/img/facebook/basket_minus.svg')">
        </div>
      </div>

      <!--receipt if there are products-->
      <div
        class="basket_content"
        v-if="$store.getters.selectedProducts.length > 0"
      >
        <!-- not enough alert-->
        <div
          class="basket_info_plashka"
          v-if="$store.getters.totalOnlyProductsNoDiscount < $store.getters.outletSettings.order_from"
        >
          <img
            :src="require('@/assets/img/facebook/info_ico.svg')"
            alt="info"
          >
          <div
            :class="{'ios-font': $store.getters.checkIos}" v-html="sanitize(text('screen_basket_remain_min_order', {'amount' : '<span>' + $options.filters.toCurrency(remainToOrder) + '</span>' }))"></div>
        </div>
        <!-- not enough alert -->

        <!-- discount -->
        <div
          class="basket_kypon"
          v-if="$store.getters.discount.name !== ''"
        >
          <div class="bk_left">
            <img
              :src="require('@/assets/img/facebook/kypon.svg')"
              alt="discount"
            >
            {{$store.getters.discount.name}}
          </div>
          <template v-if="discountPercents()">
            <div class="bk_num">
              -{{ $store.getters.discount.value }}%
            </div>
          </template>
          <template v-if="discountFixedValue()">
            <div class="bk_num">{{ $store.getters.discount.value | toCurrency }}</div>
          </template>
        </div>
        <!-- discount -->

        <!-- promocode -->
        <div
          class="basket_kypon"
          v-if="$store.getters.promocodeData"
        >
          <div class="bk_left">
            <img
              :src="require('@/assets/img/facebook/kypon.svg')"
              alt="discount"
            >
            {{$store.getters.promocodeData.name}}
          </div>
        </div>
        <ul
          v-if="$store.getters.promocodeData && $store.getters.promocodeData.auto === 1 && $store.getters.promocodeData.message !== null"
          class="basket_upsell_list"
        >
          <li class="basket_upsell_item">
            <p class="basket_upsell_text">
              {{ $store.getters.promocodeData.message }}
            </p>
          </li>
        </ul>
        <!-- promocode -->

        <!-- cashback -->
        <template v-if="$store.getters.cashbackSettings.available && $store.getters.cashbackSettings.show_message">
          <div class="basket_kypon">
            <div class="bk_left">
              <img
                :src="require('@/assets/img/facebook/wallet.svg')"
                alt="bonus"
                width="22px"
              >
              {{ $store.getters.cashbackSettings.message }}
            </div>
          </div>
        </template>
        <!-- cashback -->

        <!-- free delivery alert-->
        <div
          class="basket_kypon"
          v-if="isDelivery && hasDeliveryPrice && hasFreeDelivery && remainForFree > 0"
        >
          <div class="bk_left">
            <img
              :src="require('@/assets/img/facebook/delivery_ico.svg')"
              alt="felivery"
            >
            <span
              :class="{'ios-font': $store.getters.checkIos}" v-html="sanitize(text('screen_basket_remain_free_order', {'amount': $options.filters.toCurrency(remainForFree) }))"></span>
          </div>
        </div>
        <!-- free delivery alert -->

        <ul
          v-if="this.$store.getters.upsellMessage.length > 0"
          class="basket_upsell_list"
        >
          <li
            v-for="(item, index) of isShowUpsellMessage()"
            :key="index"
            class="basket_upsell_item "
          >
            <p class="basket_upsell_text">
              {{setUpsellMessage(item)}}
            </p>
          </li>
        </ul>

        <ul
          v-if="this.$store.getters.twoPlusOneMessage.length > 0 && this.$store.getters.twoPlusOneMessage[0]"
          class="basket_upsell_list"
        >
          <li
            v-for="(item, index) of this.$store.getters.twoPlusOneMessage"
            :key="index"
            class="basket_upsell_item "
          >
            <p class="basket_upsell_text">
              {{item}}
            </p>
          </li>
        </ul>

        <ul class="basket_list">
          <li
            :key="index"
            @click="addToBasket(product)"
            class="pointer"
            :class="{expired: $store.getters.expiredProducts !== undefined ? $store.getters.expiredProducts.find((id) => id === product.id) : false}"
            v-for="(product, index) in $store.getters.selectedProducts"
          >
            <template v-if="loader().css_direction === 'ltr'">
              <div class="bl_koll">
                {{ getItemCount(product) }}<img
                :src="require('@/assets/img/facebook/x.svg')"
                alt="x"
              >
              </div>
              <div class="bl_content">
                <div class="bl_name">{{ product.name }}</div>
                <div class="bl_content_list">
                  <receipt-options :product="product"/>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="bl_content">
                <div class="bl_name bl_name__inline">{{ product.name }}</div>
                <div class="bl_koll-wrapper">
                  <div class="bl_koll">
                    {{ getItemCount(product) }}<img
                    :src="require('@/assets/img/facebook/x.svg')"
                    alt="x"
                  >
                  </div>
                </div>
                <div class="bl_content_list">
                  <receipt-options :product="product"/>
                </div>
              </div>

            </template>
            <div class="bl_price-wrapper">
              <div
                class="bl_price bl_discounted_price"
                :class="{'ios-font': $store.getters.checkIos}"
                v-if="product.discountPercents || product.fullPrice < product.originalFullPrice"
                v-html="$options.filters.toCurrency(getOriginalPrice(product))"
              >
              </div>
              <div
                class="bl_price"
                :class="{'ios-font': $store.getters.checkIos}"
                v-html="$options.filters.toCurrency(getPrice(product))"
              >
              </div>
            </div>
          </li>

          <template v-if="discountPresent()">
            <li
              :key="'discount-' + index"
              v-for="(product, index) in $store.getters.discount.discount_data.dishes"
            >
              <div class="bl_koll">
                1 <img
                :src="require('@/assets/img/facebook/x.svg')"
                alt="x"
              >
              </div>
              <div class="bl_content">
                <div class="bl_name">{{ product.name }}</div>
                <div class="bl_content_list">
                  <receipt-options :product="product"/>
                </div>
              </div>
              <div
                class="bl_price"
                :class="{'ios-font': $store.getters.checkIos}"
                v-html="$options.filters.toCurrency($store.getters.discount.discount_data.present_price)"
              >
              </div>

            </li>
          </template>
        </ul>

        <div v-if="$store.getters.expiredProducts !== undefined && $store.getters.expiredProducts.length > 0" class="basket_list_expiredAlert">Удалите неактивные товары из&nbsp;корзины</div>

        <ul class="basket_list_result">
          <template v-if="discountPercents() || discountFixedValue() || isPromocodePresent()">
            <li>
              <span>{{ text('screen_basket_result_sum') }}</span>
              <span :class="{'ios-font': $store.getters.checkIos}" v-html="$options.filters.toCurrency($store.getters.totalOnlyProductsNoDiscount)"></span>
            </li>
          </template>
          <template v-else>
            <li>
              <span>{{ text('screen_basket_result_sum') }}</span>
              <span
                :class="{'ios-font': $store.getters.checkIos}"
                v-html="$options.filters.toCurrency($store.getters.sumProducts)"
              ></span>
            </li>
          </template>
          <template v-if="discountPercents() || discountFixedValue() || isPromocodePresent() || isSaleActive()">
            <li>
              <span>{{ text('screen_basket_result_discount') }}</span>
              <span
                :class="{'ios-font': $store.getters.checkIos}"
                v-html="$options.filters.toCurrency($store.getters.totalOnlyProductsNoDiscount - $store.getters.sumProducts)"
              ></span>
            </li>
          </template>
          <template v-if="isDelivery && hasDeliveryPrice && (!hasFreeDelivery || remainForFree > 0)">
            <li>
              <span>{{ text('screen_basket_result_delivery') }}</span>
              <span
                :class="{'ios-font': $store.getters.checkIos}"
                v-html="$options.filters.toCurrency($store.getters.deliveryPrice)"
              ></span>
            </li>
          </template>
          <!-- Сервисный сбор -->
          <template v-if="$store.getters.shopMode === 0 && $store.getters.outlet.data.service_fee.is_active === 1 && $store.getters.serviceFeePrice > 0">
            <li>
              <span>{{ $store.getters.outlet.data.service_fee.name }}</span>
              <span
                :class="{'ios-font': $store.getters.checkIos}"
              >{{ $options.filters.toCurrency( $store.getters.serviceFeePrice ) }}</span>
            </li>
          </template>
          <template v-else-if="$store.getters.shopMode === 1 && $store.getters.outlet.outlet.service_fee.is_active === 1 && $store.getters.serviceFeePrice > 0">
            <li>
              <span>{{ $store.getters.outlet.outlet.service_fee.name }}</span>
              <span
                :class="{'ios-font': $store.getters.checkIos}"
              >{{ $options.filters.toCurrency( $store.getters.serviceFeePrice ) }}</span>
            </li>
          </template>
          <!-- /Сервисный сбор -->
          <li>
            <span><b>{{ text('screen_basket_result_total') }}</b></span>
            <span>
              <b
                :class="{'ios-font': $store.getters.checkIos}"
                v-html="$options.filters.toCurrency($store.getters.totalPrice)"
              ></b>
            </span>
          </li>
          <li
            v-if="$store.getters.showCustomBasketText"
            style="text-align: center"
          >
            <span style="width: 100%"><b>{{ text('custom_text_in_basket') }}</b></span>
          </li>
        </ul>

        <span
          class="input input_style bl_comment"
          v-if="basketComment"
          :class="{ 'input--filled': focused.includes('cookComment') || cookComment.length > 0 }"
        >
          <input
            class="input__field input__field--ruri"
            type="text"
            v-model="cookComment"
            id="input_cookComment"
            @focus="focus('cookComment', 'input_cookComment')"
            @blur="unfocus"
          />
          <label
            class="input__label"
            for="input_cookComment"
          >
            <span class="input__label-content">{{ text('screen_basket_comment') }}</span>
          </label>
        </span>

        <Promocode v-if="$store.getters.promocodeAvailable"/>
        <Basket
          :page="'receipt'"
          v-if="(this.$store.getters.contactlessMode || $store.getters.outletSettings.delivery_type === 4 || this.$store.getters.canPerformOrder) &&$store.getters.enableOrder"
        />

        <transition-group name="fade">
          <div
            :key="'upsell_dark'"
            class="pu_dark"
            v-if="$store.getters.upsell.length"
            v-show="isShowUpsell"
          ></div>
        </transition-group>
        <transition-group name="slide">
          <Upsell
            :key="'upsell'"
            v-if="isShowUpsell"
          />
        </transition-group>

        <BasketClearConfirm/>
        <Options
          v-if="$store.getters.outletSettings.delivery_type !== 4 && loader().WEBVIEW_MODE === loader().const.DEFAULT"/>
        <Resource v-if="$store.getters.outletSettings.delivery_type === 4"/>
      </div>
      <!--receipt if there are products-->

      <!--receipt if there are no products-->
      <template v-else>
        <div class="basket_none">
          <div class="basket_none_inner">
            <img
              :src="require('@/assets/img/facebook/basket_none_ico.svg')"
              alt="empty"
            >
            <div class="basket_none_text">
              {{ text('screen_basket_none_title') }}
              <span v-html="sanitize(text('screen_basket_none_text'))"></span>
            </div>
          </div>
        </div>
        <div class="fixed_bottom_basket plr">
          <router-link
            :to="{ name: 'home', params: { token: this.$store.getters.token }}"
            class="fbb_btn fbb_btn_search" 
          >
            {{ text('screen_basket_none_button') }}
          </router-link>
        </div>
      </template>
    </div>
    <!--receipt if there are no products-->

  </div>

</template>

<script>
  import {DISABLE_OVERLAY} from '@/store/actions.type'

  import VueScrollTo from 'vue-scrollto'

  import loader from '@/loader'
  import Basket from '@/components/Default/Basket'
  import Options from '@/components/Default/Options'
  import BasketClearConfirm from '@/components/Default/BasketClearConfirm'
  import ReceiptOptions from '@/components/Default/Receipt/ReceiptOptions'
  import {mapGetters} from 'vuex'
  import {SET_COOK_COMMENT, SET_CURRENT_PRODUCT, SET_MODAL} from '@/store/mutations.type'
  import Promocode from '@/components/Default/Basket/Promocode'
  import Upsell from '@/components/Default/Basket/Upsell'
  import Resource from '@/components/Default/Resource/Resource'

  export default {
    name: 'Receipt',
    data() {
      return {
        focused: '',
        cookComment: '',
        upsellMessage: []
      }
    },
    watch: {
      cookComment: function (cookComment) {
        this.$store.commit(SET_COOK_COMMENT, cookComment)
      }
    },
    components: {
      Resource,
      Upsell,
      Promocode,
      ReceiptOptions,
      Basket,
      Options,
      BasketClearConfirm
    },
    methods: {
      setUpsellMessage(item) {
        const subStr = '{{amount}}'
        const msg = item.message
        if (msg && msg.indexOf(subStr)) {
          switch (item.metric) {
            case 'count':
              let valueForUpsellCount = item.value - this.$store.getters.selectedProducts.length
              valueForUpsellCount === 0 && item.operator === '>' ? valueForUpsellCount = 1 : valueForUpsellCount === 0 && item.operator === '<' ? valueForUpsellCount = -1 : valueForUpsellCount
              return msg.split(subStr).join(valueForUpsellCount)
            case 'sum':
              let valueForUpsellSum = item.value - this.$store.getters.totalOnlyProductsNoDiscount
              valueForUpsellSum === 0 && item.operator === '>' ? valueForUpsellSum = 1 : valueForUpsellSum === 0 && item.operator === '<' ? valueForUpsellSum = -1 : valueForUpsellSum
              return msg.split(subStr).join(valueForUpsellSum)
          }
        } else {
          return msg
        }
      },
      getItemCount(product) {
        if (this.$store.getters.outletSettings.delivery_type !== 4) {
          return product.count
        }
        return product.length
      },
      getOriginalPrice(product) {
        if (this.$store.getters.outletSettings.delivery_type !== 4) {
          return this.getItemCount(product) * product.originalFullPrice
        }
        return false
      },
      getPrice(product) {
        if (this.$store.getters.outletSettings.delivery_type !== 4) {
          return this.getItemCount(product) * product.fullPrice
        }
        return product.price
      },
      openClearModal() {
        this.$store.commit(SET_MODAL, {modal: 'clear', status: true})
      },
      focus(what, url) {
        if (this.focused === what) {
          return
        }
        this.focused = what

        const element = document.getElementById(url)
        VueScrollTo.scrollTo(element, 100, {
          offset: -100,
          force: true
        })
      },
      unfocus() {
        this.focused = ''
      },
      addToBasket(product) {
        this.$store.commit(SET_CURRENT_PRODUCT, product)
        if (this.$store.getters.outletSettings.delivery_type !== 4) {
          if (this.loader().WEBVIEW_MODE === this.loader().const.ECOMMERCE) {
            this.$store.commit(SET_MODAL, {modal: 'product', status: true})
          } else {
            if (product.modifiers.length > 0) {
              this.$store.commit(SET_MODAL, {modal: 'options', status: true})
            } else {
              this.$store.commit(SET_MODAL, {modal: 'count', status: true})
            }
          }
        } else {
          this.$store.commit(SET_MODAL, {modal: 'resource', status: true})
        }

      },
      isPromocodePresent() {
        if (this.$store.getters.promocodeData && this.$store.getters.promocodeData.active === 1) {
          return true
        } else {
          return false
        }
      },
      discountFixedValue() {
        return this.$store.getters.discount.discount_data.type === 2
      },
      discountPercents() {
        return this.$store.getters.discount.discount_data.type === 0
      },
      isSaleActive() {
        return this.$store.getters.sumProducts < this.$store.getters.totalOnlyProductsNoDiscount
      },
      discountPresent() {
        return this.$store.getters.discount.discount_data.type === 1
      },
      isShowUpsellMessage() {
        const currentUpsellMessages = []

        this.$store.getters.upsellMessage.forEach(e => {
          e.message !== null && !e.is_active ? currentUpsellMessages.push(e) : ''
        })

        return currentUpsellMessages
      }
    },
    computed: {
      isShowUpsell() {
        let result = true
        this.$store.getters.selectedProducts.forEach(product => {
          for (let i = 0; i < this.$store.getters.upsell.length; i++) {
            if (this.$store.getters.upsell[i].disableQty && this.$store.getters.upsell[i].id === product.id) {
              result = false
              break
            }
          }
        })
        if (this.$store.getters.modal.upsell) {
          if (result) {
            return true
          } else {
            this.$store.commit(SET_MODAL, {modal: 'upsell', status: false})
            this.$router.push({name: 'form', params: {token: this.$store.getters.token}}).catch(() => {
            })
            return false
          }
        } else {
          return false
        }
      },
      remainToOrder() {
        return this.$store.getters.outletSettings.order_from - this.$store.getters.totalOnlyProductsNoDiscount
      },
      hasDeliveryPrice() {
        return this.$store.getters.deliveryPrice !== 0
      },
      hasFreeDelivery() {
        return this.$store.getters.outletSettings.free_shipping_from > -1
      },
      remainForFree() {
        return Math.round(this.$store.getters.outletSettings.free_shipping_from - this.$store.getters.totalOnlyProductsNoDiscount)
      },
      isDelivery() {
        return this.$store.getters.outletSettings.delivery_type === 3
      },
      ...mapGetters(['basketComment'])
    },
    mounted() {
      if (this.$store.getters.overlay === true) {
        this.$store.dispatch(DISABLE_OVERLAY)
      }
    }
  }
</script>

<style scoped>
  .basket_info_plashka {
    display: flex;
    background: #fdf0f1;
    border-radius: 16px;
    font-size: 15px;
    line-height: 18px;
    padding: 20px 19px 20px 18px;
    color: #eb4253;
    margin-top: 26px;
    -webkit-align-items: center;
    align-items: center;
  }

  .basket_info_plashka span {
    font-weight: 500;
  }

  .basket_info_plashka img {
    display: block;
    margin-right: 18px;
  }

  .form-info {
    display: flex;
    background: #fdf0f1;
    border-radius: 16px;
    font-size: 15px;
    line-height: 18px;
    padding: 20px 19px 20px 18px;
    background: #f5f5f5;
    margin-top: 26px;
    -webkit-align-items: center;
    align-items: center;
  }

  .form-info span {
    font-weight: 500;
  }

  .form-info img {
    display: block;
    margin-right: 18px;
  }

  .basket_list {
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
    margin-top: 16px;
  }

  .tl_add .tl_head_price.bl_discounted_price {
    color: #a3a3a3;
    font-weight: normal;
  }

  .bl_discounted_price {
    text-decoration: line-through;
    color: #a3a3a3;
  }

  .bl_name {
    font-size: 15px;
    line-height: 120%;
    color: #1a1a1b;
    font-weight: 500;
  }

  .bl_content_list {
    font-size: 12px;
    line-height: 16px;
    color: #999999;
    margin-top: 3px;
  }

  .basket_list_result {
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
    margin-top: 15px;
    padding: 15px 16px 18px 16px;
  }

  .basket_list_result > li {
    display: flex;
    font-size: 15px;
    line-height: 120%;
    color: #999;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }

  .basket_list_result > li b {
    display: block;
    color: #1a1a1b;
    font-weight: 500;
    padding-top: 6px;
  }

  .basket_list_result > li + li {
    margin-top: 6px;
  }

  .input_style {
    display: block;
    position: relative;
    height: 52px;
  }

  .input_style input {
    display: block;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 34px;
    padding-left: 16px;
    padding-right: 16px;
    position: absolute;
    font-size: 15px;
    color: #1a1a1b;
    font-weight: 500;
    width: 100%;
    bottom: 2px;
    left: 0;
    background: none;
    border: none;
    border-bottom: 1px solid #f0f0f0;
    -webkit-transition: 0.4s;
    -moz-transition: 0.4s;
    -ms-transition: 0.4s;
    -o-transition: 0.4s;
    transition: 0.4s;
  }

  .input_style textarea {
    display: block;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 28px;
    padding-left: 16px;
    padding-right: 16px;
    position: absolute;
    font-size: 15px;
    color: #1a1a1b;
    font-weight: 500;
    width: 100%;
    padding-top: 6px;
    bottom: 2px;
    left: 0;
    background: none;
    border: none;
    border-bottom: 1px solid #f0f0f0;
    -webkit-transition: 0.4s;
    -moz-transition: 0.4s;
    -ms-transition: 0.4s;
    -o-transition: 0.4s;
    transition: 0.4s;
  }

  .input__label-content {
    position: absolute;
    font-size: 15px;
    color: #999999;
    line-height: 15px;
    left: 16px;
    top: 28px;
    -webkit-transition: 0.3s cubic-bezier(0.07, 1.14, 0.49, 1.01);
    -moz-transition: 0.3s cubic-bezier(0.07, 1.14, 0.49, 1.01);
    -ms-transition: 0.3s cubic-bezier(0.07, 1.14, 0.49, 1.01);
    -o-transition: 0.3s cubic-bezier(0.07, 1.14, 0.49, 1.01);
    transition: 0.3s cubic-bezier(0.07, 1.14, 0.49, 1.01);
    white-space: nowrap;
  }

  .input--filled .input__label-content {
    top: 5px;
    color: #1a1a1b;
    opacity: 0.4;
    font-size: 12px;
  }

  .bl_comment {
    margin-top: 8px;
  }

  .fbb_btn_disable {
    color: #999;
    background: #f5f5f5;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .fbb_btn_disable:active {
    background: #eee !important;
  }

  .bl_name__inline,
  .bl_koll-wrapper {
    display: inline-block;
  }

  .bk_left {
    display: flex;
    font-size: 15px;
    color: #1a1a1b;
    line-height: 120%;
    -webkit-align-items: center;
    align-items: center;
  }

  .basket_none {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    padding-bottom: 25px;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .basket_none img {
    display: block;
    width: 126px;
    margin: 0 auto;
  }

  .basket_none_text {
    text-align: center;
    margin-top: 32px;
    font-size: 20px;
    font-weight: 500;
    color: #1a1a1b;
    line-height: 120%;
  }

  .basket_none_text span {
    display: block;
    font-size: 14px;
    line-height: 18px;
    color: #999;
    font-weight: normal;
    margin-top: 11px;
  }

  .pointer.expired .bl_name {
    color: #CCCCCC;
  }

  .pointer.expired .bl_koll {
    color: #CCCCCC;
  }

  .pointer.expired .bl_price {
    color: #CCCCCC;
  }

  .basket_list_expiredAlert {
    margin-top: 15px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 18px;
    font-family: 'Roboto', 'sans-serif', 'arial', 'helvetica';
    font-size: 15px;
    line-height: 120%;
    color: red;
  }

</style>
